import Error404 from "../../components/common/Redirect/Error404";

const Error404Page = () => {
  return <Error404 />;
};

export default Error404Page;
